import { customEndpoint, readMe } from '@directus/sdk';

import { directusClient } from '../../services/directusClient/directusClient.ts';

interface PolicyGlobals {
  admin_access: boolean;
  app_access: boolean;
}

/**
 * The logged-in user with `role: { id, admin_access }`, as the app has always read it.
 *
 * Since Directus 11, admin access is a property of the user's policies, not of the role, and
 * asking for `role.admin_access` makes /users/me return nothing but the id. So the user and the
 * policy globals are fetched separately and admin_access is put back on the role object.
 */
export const readMeWithAdminAccess = async () => {
  const [me, globals] = await Promise.all([
    directusClient.request(readMe({ fields: ['*', { role: ['id'] }] })),
    directusClient.request(customEndpoint<PolicyGlobals>({ path: '/policies/me/globals', method: 'GET' })),
  ]);
  const role = me.role as { id?: string } | null;

  return { ...me, role: role ? { ...role, admin_access: globals.admin_access } : role };
};
